
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { Amount, GetDate, ReverseFormatDate, formatDate, setFocus, setTitle } from '../Common/Common'
import Loader from "../Layout/Loader";
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useRef } from 'react';
import { getCommonData } from '../Common/CommanServices';
import { post } from '../Common/service';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";

const OrderEntry = ({ open, setOpen }) => {
    const inputrefs = useRef([]);
    const cookies = new Cookies();
    const navigate = useNavigate();
    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode');
    const [MenuText, setMenuText] = useState("Order Entry");

    const [InvoiceData, setInvoiceData] = useState({
        TotalIssuedQty: 0,
        TotalNetAmount: 0,
        GETFUNDPer: 0,
        GetFundAmount: 0,
        NHILPer: 0,
        NhilAmount: 0,
        COVIDPer: 0,
        CovidAmount: 0,
        VATPer: 0,
        VatAmount: 0,
        GrandTotalAmount: 0
    });

    const [isLoading, setIsLoading] = useState(false);
    const [SalesPerson, setSalesPerson] = useState([]);
    const [SalesPersonPre, setSalesPersonPre] = useState('')
    const [CustomerData, setCustomerData] = useState([]);
    const [ItemNoData, setItemNoData] = useState([]);

    const [SaveData, setSaveData] = useState({
        OrderNo: "Syatem-Generated",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        Customer: "",
        ContactPerson: "",
        OrderDate: GetDate(0),
        DeliveryDate: GetDate(1),
        Remarks: "",
        TotalItem: "",
        ItemTotalAmount: 0.00,
        ItemDetails: [{
            ItemNo: "",
            Quantity: 0,
            UnitPrice: 0.00,
            ItemTotal: 0.00,
            ItemDeliveryDate: GetDate(1),
        }]
    });

    const HandleChange = (prop, value) => {
        setSaveData(SaveData => ({ ...SaveData, [prop]: value }));
    }

    const handleInvoiceData = () => {
        let LoginUserCode = cookies.get('loginUserCode');
        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            let data = {
                Token, LoginUserCode: LoginUserCode,
            }
            post(`${API_SERVER}/api/Operation/GetInvoiceChargePer`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    setInvoiceData({
                        ...InvoiceData,
                        GETFUNDPer: +res.getFundPer,
                        NHILPer: +res.nhilPer,
                        COVIDPer: +res.covidLevyPer,
                        VATPer: +res.vatPer
                    });
                }
                else if (res.status === "EXPIRED") {
                    navigate('/Login')
                }
                else if (res.message !== "") {
                    AlertBox(res.status, res.message, '');
                }
                setIsLoading(false);
            })
        };
    }

    useEffect(() => {
        if (SaveData.ItemDetails !== undefined) {
            if (SaveData.ItemDetails.length > 0) {
                handleCalulateAmount();
            } else {
                setInvoiceData({
                    ...InvoiceData,
                    TotalIssuedQty: 0,
                    TotalNetAmount: 0,
                    GetFundAmount: 0,
                    NhilAmount: 0,
                    CovidAmount: 0,
                    VatAmount: 0,
                    GrandTotalAmount: 0
                });
            }
        }
    }, [SaveData.ItemDetails]);

    const handleCalulateAmount = () => {
        SaveData.ItemDetails?.map((item, index) =>
            SaveData.ItemDetails[index].ItemTotal = (+SaveData.ItemDetails[index].Quantity * + SaveData.ItemDetails[index].UnitPrice).toFixed(2)
        );
        const ItemTotalAmount = SaveData.ItemDetails.reduce((acc, item) => acc + +item.ItemTotal, 0).toFixed(2).toString();
        setSaveData({
            ...SaveData,
            TotalItem: SaveData.ItemDetails.length.toString(),
            ItemTotalAmount: ItemTotalAmount,
        })
        const GetFundAmount = ((+ItemTotalAmount * +(InvoiceData.GETFUNDPer)) / 100.00).toFixed(2)
        const NhilAmount = ((+ItemTotalAmount * +(InvoiceData.NHILPer)) / 100.00).toFixed(2)
        const CovidAmount = ((+ItemTotalAmount * +(InvoiceData.COVIDPer)) / 100.00).toFixed(2)
        const VatAmount = (((+ItemTotalAmount) * +(InvoiceData.VATPer)) / 100.00).toFixed(2)
        const GrandTotalAmount = (+ItemTotalAmount + +GetFundAmount + +NhilAmount + +CovidAmount + +VatAmount).toFixed(2)
        console.log(VatAmount)
        setInvoiceData({
            ...InvoiceData,
            GetFundAmount: GetFundAmount,
            NhilAmount: NhilAmount,
            CovidAmount: CovidAmount,
            VatAmount: VatAmount,
            GrandTotalAmount: GrandTotalAmount
        })
    }

    useEffect(() => {
        handleInvoiceData()
        setFocus('txtSalesPerson');
        setTitle('OrderEntry', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500);
    }, [])

    const handleGetItemDetails = async (ItemNo, RowIndex) => {
        const Token = await cookies.get('token');
        let LoginUserCode = await cookies.get('loginUserCode');

        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = {
                Token: Token, LoginUserCode: LoginUserCode, ItemNo: SaveData.ItemDetails[RowIndex].ItemNo, SalesPerson: SaveData.SalesPerson, Customer: SaveData.Customer
            }
            post(`${API_SERVER}/api/Operation/ValidateItemForRequestList`, { ...data }, (res) => {
                if (res.status === 'SUCCESS') {
                    const isDuplicate = SaveData.ItemDetails?.some((item, index) => (item.ItemNo === res.item && index !== RowIndex));
                    if (!isDuplicate) {
                        const newformItemDetails = [...SaveData.ItemDetails];
                        newformItemDetails[RowIndex].ItemNo = res.item;
                        newformItemDetails[RowIndex].UnitPrice = res.itemPrice.toString();
                        setSaveData({
                            ...SaveData,
                            ItemDetails: newformItemDetails,
                        });
                        setFocus(`txtQuantity${RowIndex + 1}`)
                    }
                    else {
                        AlertBox(res.status, 'Item No Already Exists !.', '');
                        setFocus(`txtItem${RowIndex + 1}`)
                    }

                    setIsLoading(false);
                }
                else if (res.message === "EXPIRED") {
                    navigate('/Login')
                }
                else if (res.message !== "") {
                    const newformItemDetails = [...SaveData.ItemDetails];
                    newformItemDetails[RowIndex].UnitPrice = '';
                    setSaveData({
                        ...SaveData,
                        ItemDetails: newformItemDetails,
                    });
                    setIsLoading(false);
                    AlertBox(res.status, res.message, `txtItem${RowIndex + 1}`);
                }
                setIsLoading(false);
            })
        }
    }

    const handleAddTableRow = () => {
        let ErrorMsg = '', Focus = '', ItemRowsCount = SaveData.ItemDetails.length - 1
        if (SaveData.ItemDetails[ItemRowsCount].ItemNo === '') {
            ErrorMsg = 'Please Enter Last Item No !.';
            Focus = 'txtItem' + (ItemRowsCount + 1);
        }
        else if (SaveData.ItemDetails[ItemRowsCount].Quantity === 0) {
            ErrorMsg = 'Please Enter Last ItemQuantity !.';
            Focus = 'txtQuantity' + (ItemRowsCount + 1);
        }
        else if (SaveData.ItemDetails[ItemRowsCount].ItemDeliveryDate === '') {
            ErrorMsg = 'Please Enter Last ItemDeliveryDate !.';
            Focus = 'txtDeliveryDate' + (ItemRowsCount + 1);
        }
        else {
            const newItem = ({
                ItemNo: "",
                Quantity: 0,
                UnitPrice: 0.00,
                ItemTotal: 0.00,
                ItemDeliveryDate: SaveData.DeliveryDate,
            });
            const newItemDetails = [...SaveData.ItemDetails, newItem];
            setSaveData({ ...SaveData, ItemDetails: newItemDetails });
            setTimeout(() => {
                setFocus('txtItem' + (ItemRowsCount + 2))
            }, 500)
        }
        if (ErrorMsg !== '') {
            AlertBox("error", ErrorMsg, Focus);
        }
    };

    const handleRemoveTableRow = (rowIndex) => {
        if (SaveData.ItemDetails.length > 1) {
            const updatedItemDetails = [...SaveData.ItemDetails];
            updatedItemDetails.splice(rowIndex, 1);
            setSaveData({
                ...SaveData,
                ItemDetails: updatedItemDetails,
            });
        }
    };

    const handleSubmitData = async () => {
        Swal.fire({
            title: "Do you want to Save Order ?",
            showDenyButton: true,
            showCancelButton: false,
            icon: "info",
            confirmButtonText: "Yes",
            denyButtonText: "No"
        }).then((result) => {
            if (result.isConfirmed) {
                if (SaveData.ItemDetails.filter(item => item.ItemTotal > 0).length <= 0) {
                    AlertBox("error", 'Please fill any item detail !.', `txtItem${SaveData.ItemDetails.length}`);
                    return false;
                }
                else {
                    const loginUserCode = String(LoginUserCode)
                    setIsLoading(true)
                    let data = {
                        ...SaveData, Token, LoginUserCode: loginUserCode, Source: 'WEB'
                    }
                    post(`${API_SERVER}/api/Operation/SaveOrderEntry`, { ...data }, (res) => {
                        if (res.status === 'SUCCESS') {
                            AlertBox(res.status, res.message, '');
                            handleClearData();
                        }
                        else if (res.message === "EXPIRED") {
                            navigate('/Login')
                        }
                        else if (res.message !== "") {
                            AlertBox("error", res.message, '');
                            setIsLoading(false);
                        }
                        setFocus(res.focus);
                    })
                }
            }
        });
    }

    const handleClearData = () => {
        setSaveData({
            ...SaveData,
            OrderNo: "Syatem-Generated",
            SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
            Customer: "",
            ContactPerson: "",
            OrderDate: GetDate(0),
            DeliveryDate: GetDate(1),
            Remarks: "",
            TotalItem: "",
            ItemTotalAmount: 0.00,
            ItemDetails: [{
                ItemNo: "",
                Quantity: 0,
                UnitPrice: "",
                ItemTotal: "",
                ItemDeliveryDate: GetDate(1),
            }]
        });
        setIsLoading(false);
    }

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    const getCustomer = () => {
        setCustomerData([])
        let temp = {
            Type: "GetCustomer",
            Prefix: "",
            ContextKey: SalesPersonPre.split(':')[0].trim(),
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerData(CustomerDatalist);
            } else {
                setCustomerData([]);
            }
        });
    }

    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }
    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    let CustomerArr = []
    for (let i = 0; i < CustomerData.length; i++) {
        let mydata = CustomerData[i]?.values
        CustomerArr.push(mydata)
    };
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row">
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Order No<span className="Required">*</span></label>

                                            <input
                                                id='txtOrderNo'
                                                maxLength="50"
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtSalesPerson');
                                                    };
                                                }}
                                                disabled
                                                className="form-control"
                                                placeholder='Enter Order No'
                                                value={SaveData.OrderNo}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCustomer") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={SaveData.SalesPerson ? SaveData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                    setSalesPersonPre(newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-12">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItem1") };
                                                }}
                                                label='Customer '
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomer'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={SaveData.Customer ? SaveData.Customer : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Customer', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Contact Person</label>
                                            <input
                                                id='txtContactPerson'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtOrderDate');
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Contact Person'
                                                value={SaveData.ContactPerson}
                                                onChange={(e) => {
                                                    setSaveData({ ...SaveData, ContactPerson: e.target.value })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Order Date <span className="Required">*</span></label>
                                            <DatePicker selected={ReverseFormatDate(SaveData.OrderDate)}
                                                id='txtOrderDate'
                                                disabled={true}
                                                className="form-control"
                                                placeholderText='Select Order Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setSaveData({ ...SaveData, OrderDate: formatDate(date) })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtDeliveryDate');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Estimated Delivery Date <span className="Required">*</span></label>
                                            <DatePicker selected={ReverseFormatDate(SaveData.DeliveryDate)}
                                                id='txtDeliveryDate'
                                                className="form-control"
                                                placeholderText='Select Delivery Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                minDate={new Date()}
                                                onChange={(date) => {
                                                    setSaveData({
                                                        ...SaveData,
                                                        DeliveryDate: formatDate(date),
                                                    });
                                                    (SaveData?.ItemDetails?.length === 1 ? (
                                                        SaveData.ItemDetails[0].ItemDeliveryDate = formatDate(date)
                                                    ) : (<></>))
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtItem1');
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/*Item detail section Start*/}
                                    <div className="col-lg-12 col-md-12 col-sm-12 mt-2">
                                        <div className="heading-box">
                                            <div className="heading d-flex gap-4">
                                                <h6 className="m-0 font-weight-bold text-primary" >Item Details</h6>
                                            </div>
                                        </div>
                                        <div className="op-invoice recoard-bata service-content-area" style={{ padding: '0rem 0rem 0rem 0rem' }}>
                                            <div className="table-responsive">
                                                <table className="table-bordered" cellSpacing="0" style={{width:"100%"}}>
                                                    <thead className="sticky-top">
                                                        <tr>
                                                            <th>Del</th>
                                                            <th >Item<span className="Required">*</span></th>
                                                            <th style={{ textAlign: 'right' }}>Quantity<span className="Required">*</span></th>
                                                            <th style={{ textAlign: 'right' }}>Unit Price<span className="Required">*</span></th>
                                                            <th style={{ textAlign: 'right' }}>Total<span className="Required">*</span></th>
                                                            <th>DeliveryDate<span className="Required">*</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {SaveData?.ItemDetails ?
                                                            (
                                                                SaveData?.ItemDetails?.map((row, rowIndex) => (
                                                                    <tr key={rowIndex}>
                                                                        <td className='fields'>
                                                                            <button title="Delete Item" className="btn btn-link text-danger btn-sm"
                                                                                onClick={() => { handleRemoveTableRow(rowIndex) }}
                                                                            >
                                                                                <i className="bi bi-trash"></i>
                                                                            </button>
                                                                        </td>
                                                                        <td className="col-lg-6 col-md-6 col-sm-12 col-12"  >
                                                                            <div className="fields">
                                                                                <AutoCompleteBox
                                                                                    inputrefs={inputrefs}
                                                                                    style={{ minWidth: '200px' }}
                                                                                    label=''
                                                                                    placeholder="Item"
                                                                                    maxLength='50'
                                                                                    options={ItemNoArr}
                                                                                    id={`txtItem${rowIndex + 1}`}
                                                                                    required={true}
                                                                                    ignore_common={true}
                                                                                    onFocus={() => getItemNo()}
                                                                                    inputValue={SaveData.ItemDetails[rowIndex].ItemNo}
                                                                                    onInputChange={(e, newInputValue) => {
                                                                                        const newformItemDetails = [...SaveData.ItemDetails];
                                                                                        newformItemDetails[rowIndex].ItemNo = newInputValue;
                                                                                        setSaveData({
                                                                                            ...SaveData,
                                                                                            ItemDetails: newformItemDetails,
                                                                                        });
                                                                                    }}
                                                                                    onBlur={(e) => {
                                                                                        if (e.target.value !== "") {
                                                                                            handleGetItemDetails(e.target.value, rowIndex)
                                                                                        }
                                                                                    }}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            setFocus(`txtQuantity${rowIndex + 1}`);
                                                                                        };
                                                                                    }}
                                                                                />
                                                                            </div>

                                                                        </td>
                                                                        <td className='fields'>
                                                                            <input className="form-control" type='text'
                                                                                id={`txtQuantity${rowIndex + 1}`}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                                        setFocus(`txtDeliveryDate${rowIndex + 1}`);
                                                                                    }
                                                                                }}
                                                                                style={{ textAlign: 'right' }}
                                                                                maxLength="10"
                                                                                value={SaveData.ItemDetails[rowIndex].Quantity}
                                                                                onChange={(e) => {
                                                                                    const newFormItemDetails = [...SaveData.ItemDetails];
                                                                                    newFormItemDetails[rowIndex].Quantity = Amount(e.target.value);
                                                                                    newFormItemDetails[rowIndex].ItemTotal = newFormItemDetails[rowIndex].Quantity * SaveData.ItemDetails[rowIndex].UnitPrice;
                                                                                    setSaveData({
                                                                                        ...SaveData,
                                                                                        ItemDetails: newFormItemDetails,
                                                                                    });
                                                                                }}
                                                                                onFocus={(e) => { e.target.select() }}

                                                                            />
                                                                        </td>
                                                                        <td className='fields' style={{ textAlign: 'right' }}>
                                                                            {SaveData.ItemDetails[rowIndex].UnitPrice}
                                                                        </td>
                                                                        <td className='fields' style={{ textAlign: 'right' }}>
                                                                            {SaveData.ItemDetails[rowIndex].ItemTotal}
                                                                        </td>
                                                                        <td className='fields'>
                                                                            <DatePicker
                                                                                selected={ReverseFormatDate(SaveData.ItemDetails[rowIndex].ItemDeliveryDate)}
                                                                                id={`txtDeliveryDate${rowIndex + 1}`}
                                                                                className="form-control"
                                                                                placeholderText="Select Item Delivery Date"
                                                                                dateFormat="dd-MMM-yyyy"
                                                                                autoComplete="off"
                                                                                minDate={new Date()}
                                                                                onChange={(date) => {
                                                                                    const newformItemDetails = [...SaveData.ItemDetails];
                                                                                    newformItemDetails[rowIndex].ItemDeliveryDate = formatDate(date);
                                                                                    setSaveData({
                                                                                        ...SaveData,
                                                                                        ItemDetails: newformItemDetails,
                                                                                    });
                                                                                }}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                                        setFocus('btnAddItem');
                                                                                    }
                                                                                }}
                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            )
                                                            : (
                                                                <></>
                                                            )}

                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="col-md-12 col-sm-12 col-xs-12" >
                                                <button className="btn btn-success btn-sm itemAddButton" type="button" id='btnAddItem'
                                                    onClick={() => { handleAddTableRow() }}
                                                    title="Add New Item"><i className="bi bi-plus"></i> Add New</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-12 mt-2">
                                        <div className="fields">
                                            <label className="form-label">Remarks</label>
                                            <textarea style={{ height: "100px" }}
                                                id='txtRemarks'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtTotalItem');
                                                    };
                                                }}
                                                type="text"
                                                className="form-control"
                                                placeholder="Remarks"
                                                autoComplete="off"
                                                maxLength='200'
                                                value={SaveData.Remarks}
                                                onChange={(e) => {
                                                    setSaveData({ ...SaveData, Remarks: e.target.value })
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-12 mt-2">
                                        <div className="row ">
                                            <div className="col-lg-12">
                                                <div className="fields">
                                                    <label className="form-label">Total Items<span className="Required">*</span></label>
                                                    <input
                                                        id='txtTotalItem'
                                                        type="text"
                                                        style={{ textAlign: 'right' }}
                                                        disabled
                                                        maxLength="10"
                                                        className="form-control"
                                                        value={SaveData.TotalItem}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="fields">
                                                    <label className="form-label">Total Amount<span className="Required">*</span></label>
                                                    <input
                                                        id='txtItemTotalAmount'
                                                        type="text"
                                                        style={{ textAlign: 'right' }}
                                                        disabled
                                                        maxLength="10"
                                                        className="form-control"
                                                        value={SaveData.ItemTotalAmount}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-5 col-md-5 col-sm-12 mt-2">
                                        <div className="row justify-content-end">
                                            <div className="col-lg-12 col-md-12 col-sm-12 mt-2">

                                                <div className="op-invoice recoard-bata service-content-area">
                                                    <div className="table-responsive">
                                                        <table className="table-bordered" width="100%" cellSpacing="0">
                                                            <thead className="sticky-top">
                                                                <tr>
                                                                    <th colSpan='2'>Invoice Detail</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td style={{ textAlign: 'right' }}><b>GETFUND ({InvoiceData.GETFUNDPer.toFixed(2)} %)</b></td>
                                                                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.GetFundAmount}</b></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: 'right' }}><b>NHIL ({InvoiceData.NHILPer.toFixed(2)} %)</b></td>
                                                                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.NhilAmount}</b></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: 'right' }}><b>COVID LEVY ({InvoiceData.COVIDPer.toFixed(2)} %)</b></td>
                                                                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.CovidAmount}</b></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: 'right' }}><b>VAT ({InvoiceData.VATPer.toFixed(2)} %)</b></td>
                                                                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.VatAmount}</b></td>
                                                                </tr>
                                                                <tr>
                                                                    <td style={{ textAlign: 'right' }}><b>Grand Total Amount</b></td>
                                                                    <td style={{ textAlign: 'right' }}><b>{InvoiceData.GrandTotalAmount}</b></td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-3">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSave'
                                                onClick={handleSubmitData}
                                            >
                                                <i className="bi bi-check-lg" /> Save
                                            </button>
                                            <button className="button reset-btn" id='btnReset' onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}

        </main>
    )
}
export default OrderEntry
